import NewsletterForm from "@/components/feature/NewsletterForm";

const reasons = [
  { icon: "ri-flashlight-line", text: "独家首发内容优先触达，比热搜早一步" },
  { icon: "ri-filter-3-line", text: "每周两到三次精选，不做无意义的数量推送" },
  { icon: "ri-shield-check-line", text: "完整信息链路与更正记录，拒绝以讹传讹" },
];

export default function SubscribeSection() {
  return (
    <section id="subscribe" aria-labelledby="subscribe-title" className="mx-auto w-full max-w-shell px-4 pb-16 pt-4 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-lg bg-foreground-950 px-6 py-10 md:px-10 md:py-14">
        <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-accent-400">
              <span className="h-px w-6 bg-accent-400" />
              邮件订阅
            </p>
            <h2 id="subscribe-title" className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              别在现场之外，错过真正的内幕
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200/80">
              留下邮箱，我们会在下一次独家猛料发布时第一时间通知你。不发广告，不做转卖。
            </p>
            <ul className="mt-6 space-y-3">
              {reasons.map((item) => (
                <li key={item.text} className="flex items-start gap-2.5 text-sm text-background-200/90">
                  <span className="mt-0.5 flex h-5 w-5 items-center justify-center">
                    <i className={`${item.icon} text-accent-400`} aria-hidden="true" />
                  </span>
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-100/15 bg-background-50/5 p-5 md:p-7">
              <h3 className="font-heading text-lg font-bold text-background-50">订阅独家推送</h3>
              <p className="mt-1 text-xs text-background-200/70">
                输入邮箱即可加入，已有 42 万读者通过邮件收到我们的独家内容。
              </p>
              <div className="mt-5">
                <NewsletterForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}